import { createRouter, createWebHistory } from 'vue-router'

import routes from './routes'
import { setupRouterGuards } from './guards'

const routerBase = import.meta.env.VITE_ROUTER_BASE || '/'

const router = createRouter({
  history: createWebHistory(routerBase),
  routes
})

setupRouterGuards(router)

export default router
